import { SetPasswordCard } from "@/components/SetPasswordCard";
import { useAuth } from "@/auth/AuthContext";

export function ResetPasswordPage() {
  const { resetPassword } = useAuth();

  return (
    <SetPasswordCard
      title="Choose a new password"
      subtitle="Set a new password for your Summit account."
      submitLabel="Reset password and sign in"
      invalidLinkMessage="This password reset link is missing its token. Request a new one from the sign-in page."
      genericErrorMessage="Could not reset your password."
      onSubmit={resetPassword}
    />
  );
}
